@if (project && projectEditForm) {
  <div aria-hidden="false" tabindex="0">
    @if (isProject) {
      <app-project-relations-edit>
      </app-project-relations-edit>
    }
    @if (isStrategy) {
      <app-strategy-relations-edit>
      </app-strategy-relations-edit>
    }
    @if (isWholeSystem) {
      <app-whole-system-relations-edit>
      </app-whole-system-relations-edit>
    }
    @if (isProgramManagement) {
      <app-program-management-relations-edit>
      </app-program-management-relations-edit>
    }
  </div>
}
